import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-catalogo-detalles-default',
  templateUrl: './catalogo-detalles-default.component.html',
  styleUrls: ['./catalogo-detalles-default.component.scss']
})
export class CatalogoDetallesDefaultComponent implements OnInit {

  @Input() public title:string = "";
  @Input() public body:string = "";
  @Input() public footer_title:string = "";
  @Input() public footer_body:string = "";
  @Input() public tabs:any = false;
  conceptoSelected : any;


  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/partials/catalogo-detalles-default/catalogo-detalles-default.component.ts